import { render } from "./ForgotPassword.vue?vue&type=template&id=b9c8caf4&xmlns%3ASchemaFormWithValidation=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"
script.render = render

export default script